import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { SubscriptionService } from '../../services/subscription.service'; // Pas pad aan
import { UserSubscriptionService } from 'src/app/services/user-subscription.service';

@Component({
  selector: 'app-subscription-banner',
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule],
  templateUrl: './subscription-banner.component.html',
  styleUrls: ['./subscription-banner.component.scss']
})
export class SubscriptionBannerComponent implements OnInit {
  showBanner = false;
  bannerMessage = '';
  bannerType: 'warning' | 'info' | 'danger' = 'warning';
  bannerIcon = 'info';

  constructor(private userSubscriptionService: UserSubscriptionService) {}

  ngOnInit() {
    this.userSubscriptionService.getUserSubscription().subscribe(sub => {
      this.evaluateBanner(sub);
    });
  }

  private evaluateBanner(sub: any) {
    console.log('subscription banner: evaluateBanner', sub);
    if (!sub) {
      this.showBanner = false;
      return;
    }

    const today = new Date();
    const endDate = new Date(sub.endDate);
    const daysLeft = Math.ceil((endDate.getTime() - today.getTime()) / (1000 * 3600 * 24));

    // 1. Proefperiode
    if (sub.isTrial) {
      this.showBanner = true;
      this.bannerType = 'warning';
      this.bannerIcon = 'hourglass_top';
      this.bannerMessage = `Your trial period ends in <strong>${daysLeft} days</strong>.`;
      return;
    }

    // 2. Geen automatische verlenging & <= 14 dagen
    if (!sub.autoRenew && daysLeft <= 14 && daysLeft > 0) {
      this.showBanner = true;
      this.bannerType = 'danger';
      this.bannerIcon = 'warning';
      this.bannerMessage = `Your subscription ends in <strong>${daysLeft} days</strong>.`;
      return;
    }

    // 3. Verlopen
    if (sub.isExpired) {
      this.showBanner = true;
      this.bannerType = 'danger';
      this.bannerIcon = 'error';
      this.bannerMessage = `Your subscription has expired, renew to continue.`;
      return;
    }

    this.showBanner = false;
  }
}